import capitalize from 'lodash.capitalize';

import { Warranty } from '@gds/Icons/Paths/Warranty';
import Pill from '@gds/Pill/Pill';
import { Typography } from '@gds/Typography/Typography';

import styles from './GuaranteeTag.module.css';

export const GuaranteeTag = ({
  handleClick,
  className = '',
  name,
  duration,
  messages,
}: {
  handleClick?: () => void;
  className?: string;
  name?: string;
  duration?: number;
  messages: Record<string, string>;
}) => {
  if (!name && !duration) return null;

  return (
    <Pill
      className={`${className} ${styles.labelWrapper}`}
      onClick={handleClick}
      data-test-id="guarantee-pill"
    >
      <Warranty />
      <div>
        {!!name && <Typography variant="buttonLink2">{name}</Typography>}
        {!!duration && (
          <Typography variant="subheading3" className={styles.guaranteeTagMonth}>
            {name ? ` (${messages.guaranteeDuration})` : capitalize(messages.guaranteeDuration)}
          </Typography>
        )}
      </div>
    </Pill>
  );
};
